export default __webpack_public_path__ + "static/media/d_search.2e70dccc.png";